module.exports = __webpack_public_path__ + "static/media/background_sl@2x.47b0d188.png";